export const ForgotPasswordIllustration = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={438}
    height={683}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M169.433 1.11c4.519 2.583 8.106 8.897 8.106 14.064v138.639l41.102 23.753v143.016c0 5.167-3.658 7.248-8.105 4.664-4.52-2.583-8.106-8.898-8.106-14.064V186.894l-41.175-23.68V5.774c0-5.167 3.659-7.248 8.178-4.665Z"
      opacity={0.3}
    />
    <path
      fill="url(#b)"
      d="M191.813 603.314c4.519 2.584 8.106.503 8.106-4.664V494.742l41.103 23.753v-68.028c0-5.167-3.658-11.482-8.106-14.065-4.519-2.583-8.106-.502-8.106 4.664v49.299l-41.102-23.752v122.636c0 5.167 3.658 11.482 8.105 14.065Z"
      opacity={0.3}
    />
    <path
      fill="url(#c)"
      d="M255.01 102.864c4.519 2.583 8.106 8.898 8.106 14.065v235.873c0 5.167-3.659 7.248-8.106 4.665-4.519-2.584-8.106-8.899-8.106-14.065V107.528c0-5.166 3.658-7.247 8.106-4.664Z"
      opacity={0.3}
    />
    <path
      fill="#FBD1A2"
      d="M208.957 591.474c0 14.208-8.321 20.954-18.578 14.998-10.258-5.885-18.579-22.246-18.579-36.454 0-14.208 8.321-20.954 18.579-14.998 10.257 5.884 18.578 22.246 18.578 36.454Z"
    />
    <path
      fill="url(#d)"
      d="M345.465 221.124c-4.52-2.584-8.106-.503-8.106 4.664v70.037l-41.103-23.752v86.039c0 5.167 3.658 11.482 8.106 14.065 4.519 2.584 8.106.503 8.106-4.664v-67.311l41.102 23.753v-88.767c0-5.166-3.658-11.481-8.105-14.064Z"
      opacity={0.3}
    />
    <path
      fill="#FBD1A2"
      d="M363.685 245.88c0 14.065-8.249 20.667-18.364 14.855-10.114-5.885-18.363-21.959-18.363-36.024 0-14.064 8.177-20.666 18.363-14.854 10.186 5.884 18.364 21.959 18.364 36.023Z"
    />
    <path
      fill="url(#e)"
      d="M424.084 604.104c0-5.167-3.659-11.482-8.106-14.065l-63.842-36.884v-53.461l-63.412-36.597c-4.519-2.584-8.106-.503-8.106 4.664s3.659 11.481 8.106 14.065l47.2 27.268v53.461l80.126 46.213c4.447 2.584 8.034.502 8.034-4.664Z"
      opacity={0.3}
    />
    <path
      fill="url(#f)"
      d="M270.002 681.891c-4.519-2.584-8.106-8.898-8.106-14.065v-170.07c0-5.166 3.658-7.247 8.106-4.664 4.519 2.583 8.106 8.898 8.106 14.065v170.069c0 5.167-3.659 7.248-8.106 4.665Z"
      opacity={0.3}
    />
    <path
      fill="#FBD1A2"
      d="M433.983 610.275c0 14.208-8.321 20.954-18.579 14.997-10.258-5.884-18.579-22.245-18.579-36.453 0-14.209 8.321-20.954 18.579-14.998 10.258 5.884 18.579 22.245 18.579 36.454Z"
    />
    <path
      fill="url(#g)"
      d="m36.656 324.816 116.78 67.454v216.426l-116.78-67.453V324.816Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m55.162 462.45 69.581 40.186v8.539l-69.58-40.185v-8.54ZM62.407 483.476l55.163 31.861v8.539l-55.162-31.861v-8.539Z"
      opacity={0.15}
    />
    <path
      fill="#FBD1A2"
      d="M81.201 522.011 0 475.08v24.183l81.273 46.931-.072-24.183Z"
    />
    <path
      fill="#fff"
      d="m120.367 413.869-18.148 14.352-12.194-15.643L74.1 426.355l-6.313-4.592 23.457-19.734 11.908 15.643 13.127-9.759 4.088 5.956Z"
      opacity={0.2}
    />
    <path
      fill="#FBD1A2"
      d="M133.997 413.511c0 8.108-4.735 11.912-10.545 8.539-5.81-3.373-10.545-12.63-10.545-20.738 0-8.109 4.735-11.912 10.545-8.54 5.81 3.373 10.545 12.702 10.545 20.739ZM79.623 429.154c0 8.109-4.734 11.912-10.544 8.539-5.81-3.372-10.545-12.629-10.545-20.738s4.734-11.912 10.545-8.539c5.81 3.372 10.544 12.629 10.544 20.738Z"
    />
    <path
      fill="url(#h)"
      d="m438 466.326-111.042-64.153v57.838L438 524.164v-57.838Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m355.364 432.599 33.427 19.303v6.96l-33.427-19.375v-6.888ZM355.435 446.52l71.159 41.046v7.033l-71.159-41.047v-7.032Z"
      opacity={0.15}
    />
    <path
      fill="#FBD1A2"
      d="M349.554 434.608c0 4.736-2.798 7.032-6.313 5.023-3.515-2.009-6.312-7.535-6.312-12.271 0-4.736 2.797-7.032 6.312-5.023 3.515 2.009 6.313 7.535 6.313 12.271Z"
    />
    <path
      fill="url(#i)"
      d="M153.078 289.439 42.035 225.286v57.838l111.043 64.153v-57.838Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m70.442 255.712 33.427 19.303v6.96l-33.427-19.303v-6.96ZM70.513 269.633l71.159 41.046v7.033l-71.159-41.047v-7.032Z"
      opacity={0.15}
    />
    <path
      fill="#FBD1A2"
      d="M64.631 257.721c0 4.736-2.797 7.032-6.312 5.023-3.515-2.009-6.313-7.535-6.313-12.271 0-4.736 2.798-7.032 6.313-5.023 3.443 2.009 6.312 7.535 6.312 12.271Z"
    />
    <path
      fill="url(#j)"
      d="M299.771 415.161c0 35.162-20.587 51.81-45.909 37.171-25.393-14.639-45.909-55.039-45.909-90.201 0-35.162 20.587-51.811 45.909-37.172 25.393 14.639 45.909 55.04 45.909 90.202Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M187 376.485c0-35.162 20.516-51.81 45.909-37.171 25.322 14.638 45.909 55.039 45.909 90.201 0 35.162-20.516 51.81-45.909 37.172C207.587 452.048 187 411.647 187 376.485Zm41.186 27.057-2.192 7.496-4.931-2.847 2.234-7.472-4.297-2.481v-4.811l5.519 3.187 1.35-4.46-5.394-3.115v-4.811l6.617 3.82 2.148-7.136 4.721 2.726-2.066 7.183 5.059 2.921 2.148-7.136 4.721 2.726-2.066 7.183 4.09 2.362v4.811l-5.355-3.092-1.262 4.511 5.142 2.969v4.811l-6.324-3.651-2.191 7.496-4.932-2.847 2.234-7.472-4.973-2.871Zm7.546-5.694-5.102-2.946-1.262 4.511 5.014 2.895 1.35-4.46Z"
      clipRule="evenodd"
      opacity={0.4}
    />
    <defs>
      <linearGradient
        id="a"
        x1={250.899}
        x2={133.128}
        y1={57.543}
        y2={261.506}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={165.76}
        x2={240.207}
        y1={578.896}
        y2={449.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={306.057}
        x2={203.906}
        y1={141.691}
        y2={318.605}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={388.974}
        x2={291.664}
        y1={186.987}
        y2={355.513}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={450.842}
        x2={288.718}
        y1={535.943}
        y2={535.925}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="f"
        x1={233.173}
        x2={306.948}
        y1={651.232}
        y2={523.642}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={165.941}
        x2={62.209}
        y1={343.884}
        y2={523.533}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="h"
        x1={395.002}
        x2={369.941}
        y1={441.463}
        y2={484.865}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="i"
        x1={110.08}
        x2={85.019}
        y1={264.576}
        y2={307.978}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="j"
        x1={263.085}
        x2={242.307}
        y1={336.106}
        y2={454.384}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
